import { PropTypes } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

type TypeBlueButtonProps = {
  variant: 'text' | 'outlined' | 'contained';
  color: PropTypes.Color;
};

export const blueButtonProps: TypeBlueButtonProps = {
  variant: 'contained',
  color: 'primary',
};

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    blueButton: {
      padding: theme.spacing(0.5, 5),
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightBold,
      borderRadius: 35,
      textTransform: 'initial',
    },

    outlinedButton: {
      padding: theme.spacing(0.5, 2),
      color: theme.palette.text.primary,
      fontWeight: theme.typography.fontWeightBold,
      textTransform: 'initial',
      border: `1px solid ${theme.palette.text.primary}`,
      borderRadius: 17,
    },

    yellowButton: {
      width: '100%',
      maxHeight: 50,
      maxWidth: 190,
      padding: theme.spacing(0.4, 2),

      color: theme.palette.primary.main,
      fontWeight: 'bold',
      textTransform: 'initial',

      border: '1px solid #FF9E1880',
      borderRadius: 18,
      backgroundColor: '#FED925',

      '&:hover': {
        backgroundColor: '#D7B511',
      },
    },

    inputs: {
      borderRadius: 17,

      '& svg': {
        width: 18,
        height: 18,
        color: theme.palette.primary.light,
      },
    },
  })
);

export default useStyles;
